// @flow
/* eslint-disable import/prefer-default-export */

import type { Reducer } from 'redux';

export const combineReducersFlat = <STATE, ACTION>(...reducers: Array<Reducer<STATE, ACTION>>) => (
  state: STATE,
  action: ACTION,
): STATE => {
  let nextState = state;
  reducers.forEach((reducer: Reducer<STATE, ACTION>) => {
    nextState = reducer.call(reducer, nextState, action);
  });
  return nextState;
};
